import { LazyLoadComponent } from '@zapier/common-components';

const LazyLoadPasswordStrengthMeter = LazyLoadComponent({
  loader: () =>
    import(
      /* webpackChunkName: 'auth-components-PasswordStrengthMeter' */ './PasswordStrengthMeter'
    ),
});

export default LazyLoadPasswordStrengthMeter;
